
import React from 'react';
import { Input } from '@/components/ui/input';
import { AlertCircle } from 'lucide-react';

interface EmailInputProps {
  email: string;
  setEmail: (email: string) => void;
  emailError: string;
  resetEmailError: () => void;
}

const EmailInput = ({ email, setEmail, emailError, resetEmailError }: EmailInputProps) => {
  return (
    <div className="space-y-2">
      <Input
        type="email"
        placeholder="Email"
        value={email}
        onChange={(e) => {
          setEmail(e.target.value);
          resetEmailError();
        }}
        required
        className={emailError ? 'border-red-500' : ''}
      />
      {emailError && (
        <div className="text-red-500 text-sm flex items-center mt-1">
          <AlertCircle size={14} className="mr-1" />
          {emailError}
        </div>
      )}
    </div>
  );
};

export default EmailInput;
